import React from "react";
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import FormatBandwidth from "./FormatBandwidth";
import { UsagePeriod } from "../models";
import { FormatDateFromString } from "./FormatDate";
import FormatNumber from "./FormatNumber";

interface UsagePeriodTableProps {
  usagePeriods: UsagePeriod[];
}

export default (props: UsagePeriodTableProps) => (
  <TableContainer>
    <Table sx={{ minWidth: 600 }}>
      <TableHead>
        <TableRow>
          <TableCell>Date</TableCell>
          <TableCell>Requests</TableCell>
          <TableCell>Bandwidth</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {props.usagePeriods
          .slice()
          .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
          .map((row) => (
            <TableRow
              key={row.createdAt}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell>
                <FormatDateFromString dateString={row.createdAt} />
              </TableCell>
              <TableCell>
                <FormatNumber value={row.usage.requests} />
              </TableCell>
              <TableCell>
                <FormatBandwidth bytes={row.usage.bandwidth} />
              </TableCell>
            </TableRow>
          )
        )}
      </TableBody>
    </Table>
  </TableContainer>
);
